<template>
  <chart-container :title="title">
    <template v-slot:controls> </template>
    <div :class="{ overlay: fullscreen }">
      <div class="d-flex justify-end mr-4 mt-1">
        <v-btn
          class="text-capitalize mb-1"
          width="20"
          height="20"
          @click="fullscreen = !fullscreen"
          outlined
          icon
        >
          <v-icon size="14">aspect_ratio</v-icon>
        </v-btn>
      </div>

      <div
        :key="key"
        :style="{ height: computedOptions.height }"
        v-bind:id="`map-${options.map}`"
      ></div>
    </div>
  </chart-container>
</template>

<script>
/*
  global jQuery
*/
window.jQuery = require("jquery");
require("jvectormap");
require("@/lib/jquery-jvectormap-co-mill.js");
require("@/lib/jquery-jvectormap-world-mill.js");

import _merge from "lodash.merge";
import ChartContainer from "@/components/dashboard/ChartContainer.vue";
import {
  findCountryCode,
  findColombiaStateCode,
  getRandomString,
} from "@/commons/util.js";

export default {
  data() {
    return {
      key: getRandomString(),
      fullscreen: false,
      mapName: "",
      regions: [],
      mapContainer: undefined,
      mapRef: undefined,
    };
  },
  components: {
    ChartContainer,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      required: false,
    },
  },
  mounted() {
    const mapNameNorm = this.options.map.trim().toLowerCase();
      this.mapName = mapNameNorm == "colombia" ? "co_mill" : "world_mill";
    this.initMap();
  },
  methods: {
    initMap() {
      console.log("initMap");
      this.regions = {};
      this.options.places.forEach((element) => {
        let code =
          this.mapName == "co_mill"
            ? findColombiaStateCode(element)
            : findCountryCode(element);
        if (code) {
          this.regions[code] = 1000;
        }
      });
      if (Object.keys(this.regions).length > 0) {
        const selector = "#map-" + this.options.map;
        this.mapContainer = jQuery(selector);
        this.mapContainer.empty();

        this.mapContainer.vectorMap({
          map: this.mapName,
          backgroundColor: "transparent",
          zoomOnScroll: false,
          zoomOnButtons: false,
          regionStyle: {
            initial: {
              fill: "#e4e4e4",
              "fill-opacity": 0.9,
              stroke: "none",
              "stroke-width": 0,
              "stroke-opacity": 0,
            },
          },
          series: {
            regions: [
              {
                values: this.regions,
                scale: ["#C8EEFF", "#00739e"],
                normalizeFunction: "polynomial",
              },
            ],
          },
          onRegionTipShow: function (e, el) {
            el.html(el.html());
          },
        });
        this.mapRef = jQuery(selector).vectorMap("get", "mapObject");
      }
    },
  },
  computed: {
    computedOptions() {
      const h = window.innerHeight * 0.9;
      const localOptions = {
        height: this.fullscreen
          ? h.toString() + "px"
          : this.computedHeigth + "px",
      };
      return _merge({}, localOptions);
    },
    computedHeigth() {
      switch (this.height) {
        case 185:
          return 173;
        case 200:
          return 188;
        case 300:
          return 289.2;
        case 340:
          return 328;
        default:
          return (this.height || 204) * 15;
      }
    },
  },
  watch: {
    fullscreen() {
      this.mapRef.remove();
      this.$nextTick(() => this.initMap());
    },
    options() {
      this.initMap();
    },
  },
};
</script>

<style>
.jvectormap-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  touch-action: none;
}

.jvectormap-tip {
  position: absolute;
  display: none;
  border: solid 1px #cdcdcd;
  border-radius: 3px;
  background: #fff;
  color: #888;
  font-family: sans-serif, Verdana;
  font-size: smaller;
  padding: 3px;
  z-index: 20;
}
.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 70px;
  background: rgba(255, 255, 255, 1);
  z-index: 10;
}
</style>